// GENERATED FILE - DO NOT EDIT

// This file has been automatically generated. Any modifications made to this file will be overwritten the next time it is regenerated. Please refrain from editing this file directly.

import PhoneNumberData from '../../types/PhoneNumberData';

import { format18 } from '../../constants';

/** Belize */
const BZ: PhoneNumberData = [501, 'BZ', 7, format18];

export default BZ;
